module.exports = __webpack_public_path__ + "media/images/mobile/rank_title-13821ae40b094cd58c105d921389750a.gif";